import type { Job as ApiJob, JobHeader as ApiJobHeader } from "randmar-api-client";

export type JobHeader = {
  applicationId: string;
  createdAt: number;
  description: string;
  status: string;
  fileNames: string[];
  jobId: string;
  type: string;
  comment?: string | null;
};

export const fromApiJobHeader = (header: ApiJobHeader | undefined): JobHeader => ({
  jobId: header?.JobId ?? "",
  status: header?.Status ?? "",
  description: header?.Description ?? "",
  type: header?.Type ?? "",
  createdAt: header?.CreatedAt ?? 0,
  applicationId: header?.ApplicationId ?? "",
  comment: header?.Comment,
  fileNames: header?.FileNames ?? [],
});

/**
 * Represents a job in a normalized format, acting as a compatibility layer
 * during the migration from legacy `IJob` to `ApiJob`.
 * This class ensures that job data can be handled consistently throughout the
 * application, regardless of its source.
 */
export default class Job {
  public readonly header?: JobHeader;

  private constructor(source: ApiJob) {
    this.header = fromApiJobHeader(source.Header);
  }

  /**
   * Creates a new `Job` instance from an `ApiJob` object from the randmar-api-client.
   * It normalizes the job header into a UI-friendly format.
   * @param source The source job object (`ApiJob`).
   * @returns A new `Job` instance with a normalized header.
   */
  public static convertFrom(source: ApiJob): Job {
    return new Job(source);
  }
}
